// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}

.starRating {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 350px;
  height: 300px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.starRating .btn {
  width: 8em;
  height: 3em;
  padding: 5px 10px;
  border: none;
  font-size: medium;
  background-color: #e63b11;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.starRating .btn:hover {
  background-color: #333;
  color: #f1f1f1;
}

.reviewForm {
  font-size: 1.3em;
}
.reviewForm .backButton {
  margin-left: 0;
}
.reviewForm h2 {
  text-align: center;
  margin: 20px 0;
}
.reviewForm p {
  text-align: center;
  margin: 20px 0;
}
.reviewForm .form {
  display: flex;
  flex-direction: column;
  margin: 0 15%;
}
.reviewForm .form label {
  font-size: 1.2em;
  margin: 10px 0;
}
.reviewForm .form .siteSelection {
  margin: 10px 0;
}
.reviewForm .form button {
  width: 8em;
  height: 3em;
  padding: 5px 10px;
  border: none;
  margin: 10px 20%;
  font-size: medium;
  background-color: #e63b11;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.reviewForm .form button:hover {
  background-color: #333;
  color: #f1f1f1;
}
.reviewForm .form .error {
  color: red;
  font-size: 0.7em;
  margin: 10px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/review.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AACA;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uCAAA;EACA,yBAAA;AACF;AACE;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AACJ;AAAI;EACE,sBAAA;EACA,cAAA;AAEN;;AAEA;EACE,gBAAA;AACF;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,kBAAA;EACA,cAAA;AAEJ;AAAE;EACE,kBAAA;EACA,cAAA;AAEJ;AAAE;EACE,aAAA;EACA,sBAAA;EAEA,aAAA;AACJ;AAAI;EACE,gBAAA;EACA,cAAA;AAEN;AAAI;EACE,cAAA;AAEN;AAAI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAEN;AADM;EACE,sBAAA;EACA,cAAA;AAGR;AAAI;EACE,UAAA;EACA,gBAAA;EACA,cAAA;AAEN","sourcesContent":[".container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin: 30px 0;\n}\n.starRating {\n  \n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  margin: 10px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 350px;\n  height: 300px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n\n  .btn {\n    width: 8em;\n    height: 3em;\n    padding: 5px 10px;\n    border: none;\n    font-size: medium;\n    background-color: #e63b11;\n    color: white;\n    cursor: pointer;\n    border-radius: 5px;\n    transition: all 0.3s ease;\n    &:hover {\n      background-color: #333;\n      color: #f1f1f1;\n    }\n  }\n}\n.reviewForm {\n  font-size: 1.3em;\n  .backButton {\n    margin-left: 0;\n  }\n  h2 {\n    text-align: center;\n    margin: 20px 0;\n  }\n  p {\n    text-align: center;\n    margin: 20px 0;\n  }\n  .form {\n    display: flex;\n    flex-direction: column;\n\n    margin: 0 15%;\n    label {\n      font-size: 1.2em;\n      margin: 10px 0;\n    }\n    .siteSelection{\n      margin: 10px 0;\n    }\n    button {\n      width: 8em;\n      height: 3em;\n      padding: 5px 10px;\n      border: none;\n      margin: 10px 20%;\n      font-size: medium;\n      background-color: #e63b11;\n      color: white;\n      cursor: pointer;\n      border-radius: 5px;\n      transition: all 0.3s ease;\n      &:hover {\n        background-color: #333;\n        color: #f1f1f1;\n      }\n    }\n    .error {\n      color: red;\n      font-size: 0.7em;\n      margin: 10px 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
